import type { CustomerGroup, SettingPriceListState } from '../../../../customer-groups';

/**
 * Whether a customer group has at least one real price list assigned. The selection lives in the
 * group's `settings` as the `priceListSelection` item; an empty array — or entries with a blank slug
 * (a not-yet-chosen row in the builder) — count as unassigned.
 */
export function hasAssignedPriceList(group: CustomerGroup): boolean {
  const setting = group.settings.find((item) => item.key === 'priceListSelection');
  const selection = (setting?.value as SettingPriceListState | null) ?? [];
  return selection.some(({ price_list_slug }) => price_list_slug !== '');
}
